import { FC, ReactNode } from "react";
import { DescriptionList } from "@postenbring/hedwig-react";
import styles from "./DetailList.module.css";

export const DetailList: FC<{ children: ReactNode }> = ({ children }) => (
  <DescriptionList className={styles.list}>{children}</DescriptionList>
);

export const DetailRow: FC<{ label: ReactNode; children: ReactNode }> = ({
  label,
  children,
}) => (
  <div className={styles.row}>
    <dt>{label}</dt>
    <dd>{children}</dd>
  </div>
);
